// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#juno_ce_dashboard #juno-learning-scroll{overflow:visible}", "",{"version":3,"sources":["webpack://./src/ui/objects/panels/ProfileCoursesPanel/style.scss"],"names":[],"mappings":"AACE,yCACE,gBAAA","sourcesContent":["#juno_ce_dashboard {\n  #juno-learning-scroll {\n    overflow: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
